import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _class, _templateObject;
const _excluded = ["children"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/web.dom-collections.iterator.js";
import classNames from "classnames";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { useSwipeable } from "react-swipeable";
import { withTheme } from "styled-components";
import { Category, StoryAction } from "../../../Core/AnalyticEvents/analyticEvents";
import { animateEnd } from "../../../Core/animation";
import getPath from "../../../Core/getPath";
import TerriaError from "../../../Core/TerriaError";
import Box from "../../../Styled/Box";
import { withViewState } from "../../Context";
import { onStoryButtonClick } from "../../Map/MenuBar/StoryButton/StoryButton";
import Styles from "../story-panel.scss";
import StoryBody from "./StoryBody";
import FooterBar from "./StoryFooterBar";
import TitleBar from "./TitleBar";
import DragWrapper from "../../Drag/DragWrapper";

/**
 *
 * @param scene The story scene to activate
 * @param terria The Terria instance
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export async function activateStory(scene, terria) {
  var _terria$analytics;
  (_terria$analytics = terria.analytics) === null || _terria$analytics === void 0 || _terria$analytics.logEvent(Category.story, StoryAction.viewScene, JSON.stringify(scene));
  if (scene.shareData) {
    const errors = [];
    await Promise.all(scene.shareData.initSources.map(async initSource => {
      try {
        await terria.applyInitData({
          initData: initSource,
          replaceStratum: true,
          canUnsetFeaturePickingState: true
        });
      } catch (e) {
        errors.push(TerriaError.from(e));
      }
    }));
    if (errors.length > 0) {
      var _scene$title;
      terria.raiseErrorToUser(TerriaError.combine(errors, {
        title: {
          key: "story.loadSceneErrorTitle"
        },
        message: {
          key: "story.loadSceneErrorMessage",
          parameters: {
            title: (_scene$title = scene.title) !== null && _scene$title !== void 0 ? _scene$title : scene.id
          }
        }
      }));
    }
  }
  terria.workbench.items.forEach(item => {
    var _terria$analytics2;
    (_terria$analytics2 = terria.analytics) === null || _terria$analytics2 === void 0 || _terria$analytics2.logEvent(Category.story, StoryAction.datasetView, getPath(item));
  });
}
const Swipeable = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const handlers = useSwipeable(props);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, handlers), {}, {
    children: children
  }));
};
let StoryPanel = observer(_class = class StoryPanel extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "keydownListener", void 0);
    _defineProperty(this, "slideRef", void 0);
    this.state = {
      isCollapsed: false,
      inView: false
    };
    this.slideRef = /*#__PURE__*/createRef();
  }
  componentDidMount() {
    const stories = this.props.viewState.terria.stories || [];
    if (this.props.viewState.currentStoryId > stories.length - 1 || this.props.viewState.currentStoryId < 0) {
      this.props.viewState.currentStoryId = 0;
    }
    this.activateStory(stories[this.props.viewState.currentStoryId]);
    this.slideIn();
    this.keydownListener = e => {
      // Use else if for keydown events so only first one is recognised in case of multiple key presses
      if (e.key === "Escape") {
        this.exitStory();
      } else if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        if (this.props.viewState.currentStoryId + 1 !== stories.length) {
          this.goToNextStory();
        }
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        if (this.props.viewState.currentStoryId !== 0) {
          this.goToPrevStory();
        }
      }
    };
    window.addEventListener("keydown", this.keydownListener, true);
  }
  slideIn() {
    this.setState({
      inView: true
    });
  }
  slideOut() {
    this.setState({
      inView: false
    });
  }
  toggleCollapse() {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    });
  }
  onClickContainer() {
    runInAction(() => {
      this.props.viewState.topElement = "StoryPanel";
    });
  }
  componentWillUnmount() {
    if (this.keydownListener) {
      window.removeEventListener("keydown", this.keydownListener, true);
    }
  }
  navigateStory(index) {
    if (index < 0) {
      index = this.props.viewState.terria.stories.length - 1;
    } else if (index >= this.props.viewState.terria.stories.length) {
      index = 0;
    }
    if (index !== this.props.viewState.currentStoryId) {
      runInAction(() => {
        this.props.viewState.currentStoryId = index;
      });
      if (index < (this.props.viewState.terria.stories || []).length) {
        this.activateStory(this.props.viewState.terria.stories[index]);
      }
    }
  }

  // This is in StoryPanel and StoryBuilder
  activateStory(_story) {
    const story = _story ? _story : this.props.viewState.terria.stories[0];
    activateStory(story, this.props.viewState.terria);
  }
  onCenterScene(story) {
    activateStory(story, this.props.viewState.terria);
  }
  goToPrevStory() {
    this.navigateStory(this.props.viewState.currentStoryId - 1);
  }
  goToNextStory() {
    this.navigateStory(this.props.viewState.currentStoryId + 1);
  }
  exitStory() {
    animateEnd(this.slideRef.current).finally(() => {
      runInAction(() => {
        this.props.viewState.storyShown = false;
      });
      this.props.viewState.terria.currentViewer.notifyRepaintRequired();
    });
    this.slideOut();
  }
  render() {
    const stories = this.props.viewState.terria.stories || [];
    const story = stories[this.props.viewState.currentStoryId];
    if (!story) {
      return null;
    }
    return /*#__PURE__*/_jsx(DragWrapper, {
      handleSelector: ".drag-handle",
      style: {
        bottom: this.props.viewState.terria.timelineStack.top !== undefined ? "146px" : "80px",
        left: "calc(50% - min(40%, 350px))",
        width: "min(80%, 700px)"
      },
      children: /*#__PURE__*/_jsx(Box, {
        onClick: () => this.onClickContainer(),
        children: /*#__PURE__*/_jsxs(_StyledBox, {
          column: true,
          rounded: true,
          className: classNames(Styles.storyContainer, {
            [Styles.isMounted]: this.state.inView
          }),
          ref: this.slideRef,
          children: [/*#__PURE__*/_jsx(_StyledBox2, {
            backgroundColor: this.props.theme.dark,
            paddedRatio: 3,
            column: true,
            className: "drag-handle",
            children: /*#__PURE__*/_jsx(TitleBar, {
              title: story.title,
              isCollapsed: this.state.isCollapsed,
              collapseHandler: () => this.toggleCollapse(),
              closeHandler: () => this.exitStory()
            })
          }), /*#__PURE__*/_jsxs(Swipeable, {
            onSwipedLeft: () => this.goToNextStory(),
            onSwipedRight: () => this.goToPrevStory(),
            children: [/*#__PURE__*/_jsx(_StyledBox3, {
              $_css: this.props.theme.blur,
              children: /*#__PURE__*/_jsx(StoryBody, {
                isCollapsed: this.state.isCollapsed,
                story: story
              })
            }), /*#__PURE__*/_jsx(_StyledBox4, {
              backgroundColor: this.props.theme.dark,
              paddedHorizontally: 3,
              fullWidth: true,
              children: /*#__PURE__*/_jsx(FooterBar, {
                goPrev: () => this.goToPrevStory(),
                goNext: () => this.goToNextStory(),
                jumpToStory: index => this.navigateStory(index),
                zoomTo: () => this.onCenterScene(story),
                currentHumanIndex: this.props.viewState.currentStoryId + 1,
                totalStories: stories.length,
                listStories: () => {
                  runInAction(() => {
                    this.props.viewState.storyShown = false;
                  });
                  onStoryButtonClick({
                    terria: this.props.viewState.terria,
                    theme: this.props.theme,
                    viewState: this.props.viewState,
                    animationDuration: 250
                  })();
                }
              })
            })]
          })]
        }, story.id)
      })
    });
  }
}) || _class;
export default withTranslation()(withViewState(withTheme(StoryPanel)));
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n              border-radius: 6px;\n              overflow: hidden;\n            "])));
var _StyledBox2 = _styled2(Box)({
  color: "white",
  cursor: "move"
});
var _StyledBox3 = _styled3(Box)(p => ({
  backgroundColor: "rgba(255, 255, 255, 0.85)",
  backdropFilter: p.$_css
}));
var _StyledBox4 = _styled4(Box).withConfig({
  displayName: "StoryPanel___StyledBox4",
  componentId: "sc-1ya3suc-0"
})({
  color: "white"
});